module.exports = __webpack_public_path__ + "static/media/aprv-btn.611812e1.svg";